import { IPDropdownCustomStyles } from 'baseComponents';
import { IPSelectableOption } from 'baseComponents/Utils/SelectableOption';

export const iconFontSize = { fontSize: '20px', marginTop: '5px' };

export const dropdownStyles: Partial<IPDropdownCustomStyles> = {
  dropdown: { minWidth: '80px' },
  listbox: { maxHeight: '250px' },
};

export const durationValueOptions: IPSelectableOption[] = Array.from({ length: 99 }, (_, i) => {
  return {
    key: i + 1,
    text: (i + 1).toString(),
  };
});

export const readOnlyRowSpace = 20;

export const taskDetailRowHeight = 32;

// the callout of a detail row never gets narrower than this, even in a narrow panel
export const minCalloutWidth = 320;
export const defaultCalloutWidth = 420;
// space kept free between the callout and the edge of the dialog
export const calloutEdgeSpace = 8;
// distance between the row and its callout
export const calloutGapSpace = 4;
